import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { useMotionValue, animate } from "framer-motion";
import { ICountUpNumber } from "Interfaces/interface.home";

function formatNumber(num: number): string {
  if (num < 10000) {
    return num.toLocaleString(); // full display
  } else if (num < 1_000_000) {
    return `${Math.round(num / 1000)}K`;
  } else if (num < 1_000_000_000) {
    return `${(num / 1_000_000).toFixed(0)}M`;
  } else {
    return `${(num / 1_000_000_000).toFixed(0)}B`;
  }
}

const CountUpNumber: React.FC<ICountUpNumber> = ({
  from = 0,
  to,
  duration = 2,
  prefix = "",
  suffix = "",
  className = "",
}) => {
  const [ref, inView] = useInView({ triggerOnce: true });
  const [current, setCurrent] = useState(from);
  const motionValue = useMotionValue(from);

  useEffect(() => {
    if (!inView) return;

    const controls = animate(motionValue, to, {
      duration,
      onUpdate: (value) => {
        setCurrent(Math.floor(value));
      },
    });

    return () => controls.stop();
  }, [inView, to, duration, motionValue]);

  return (
    <div ref={ref} className={`text-2xl md:text-4xl font-bold ${className}`}>
      {prefix}
      {formatNumber(current).toLocaleString()}
      {suffix}
    </div>
  );
};

export default CountUpNumber;
